/*
 * iLOLA login link fix (Oct 6, 2026)
 *
 * Why: Klaviyo's Customer Hub script rewrites every login/account link on the
 * storefront to "#k-hub". The hub window is not opening, so Login buttons (header,
 * Rebuy Smart Cart) went nowhere. This puts the normal Shopify login/account
 * link back and tells the hub to leave it alone (data-k-hub-ignore).
 *
 * To remove: delete the <script> line for this file in snippets/ilola-customer-state.liquid.
 */
(function () {
  if (window.__ilolaLoginFix) return;
  window.__ilolaLoginFix = true;

  var SEL = 'a[href^="#k-hub"]';

  function target() {
    try {
      return window.customerHub && window.customerHub.userId ? '/account' : '/account/login';
    } catch (e) {
      return '/account/login';
    }
  }

  function fix() {
    try {
      var links = document.querySelectorAll(SEL);
      for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('data-k-hub-ignore', 'true');
        links[i].setAttribute('href', target());
      }
    } catch (e) {}
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      fix();
    }, 60);
  }

  // Safety net: if a click lands on a #k-hub link before it was fixed, go to Shopify login instead.
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (a) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = target();
      }
    } catch (err) {}
  }, true);

  fix();
  document.addEventListener('DOMContentLoaded', fix);
  window.addEventListener('load', fix);
  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  } catch (e) {}
})();
